<template>
  <v-row dense align="end" class="fill-height">
    <v-col :class="[readOnly ? 'pt-3' : '']">
      <v-combobox
        :value="value"
        v-if="!lodash.isEmpty(facilitatorValues) && !readOnly"
        :label="field.label"
        placeholder=" "
        :items="facilitatorValues"
        outlined
        dense
        hide-details
        persistentPlaceholder
        :suffix="measurementUnit"
        background-color="white"
        :menu-props="menuProps"
        :disabled="disabled"
        @change="changeValue"
      />

      <v-text-field
        :value="value"
        v-else
        :label="field.label"
        placeholder=" "
        :disabled="readOnly || disabled"
        :outlined="!readOnly"
        dense
        hide-details
        persistentPlaceholder
        :suffix="measurementUnit"
        :background-color="readOnly ? '' : 'white'"
        @blur="changeValue"
      />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "InputText",
    props: {
      field: Object,
      value: String,
      readOnly: Boolean,
      dependencyFieldId: String,
      dependencyAnswer: Object,
      disabled: Boolean,
    },
    model: {
      prop: "value",
      event: "change",
    },
    computed: {
      facilitators() {
        if (this.loading) return [];

        if (this.dependencyFieldId) {
          if (this.dependencyAnswer?.value) {
            return this.lodash.filter(
              this.field.facilitators,
              function(e) {
                return e.dependentOfValue === this.dependencyAnswer.value;
              }.bind(this)
            );
          }

          return [];
        }

        return this.field.facilitators;
      },
      facilitatorValues() {
        let facilitators = this.lodash.orderBy(this.facilitators, ["position"], ["asc"]);

        return this.lodash.flatMap(facilitators, function(e) {
          return e.value;
        });
      },
      measurementUnit() {
        return this.field.options.measurement_unit;
      },
      menuProps() {
        return {
          auto: true,
          maxHeight: 304,
        };
      },
    },
    methods: {
      changeValue(evn) {
        if (evn?.target) {
          return this.$emit("change", evn.target.value);
        }

        this.$emit("change", evn);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
